import React from "react";
import PropTypes from "prop-types";

import DialpadRenderer from "./DialpadRendrerClass";

const Dialpad = (props) => {
  const {
    style,
    itemRef,
    itemPosition,
    activePosition,
    elementDimensions,
    itemDimensions,
    canvasSize,
		discFillColor,
		discStrokeColor,
		circlesFillColor,
		circlesStrokeColor,
		circlesHighlightColor,
		textFillColor,
		textStrokeColor,
		arrowFillColor,
		arrowStrokeColor,
		callback} = props;



  Dialpad.propTypes = {
    canvasSize:PropTypes.number,
    discFillColor:PropTypes.string,
    discStrokeColor:PropTypes.string,
    circlesFillColor:PropTypes.string,
		circlesStrokeColor:PropTypes.string,
		circlesHighlightColor:PropTypes.string,
		textFillColor:PropTypes.string,
		textStrokeColor:PropTypes.string,
		arrowFillColor:PropTypes.string,
		arrowStrokeColor:PropTypes.string,
		callback:PropTypes.func
  };

  Dialpad.defaultProps = {
    canvasSize:250,
		discFillColor:'transparent',
		discStrokeColor:'black',
		circlesFillColor:'black',
		circlesStrokeColor:'transparent',
		circlesHighlightColor:'red',
		textFillColor:'white',
		textStrokeColor:'transparent',
		arrowFillColor:'black',
		arrowStrokeColor:'transparent',
		callback : ()=>{}
  };

  return (
    <DialpadRenderer
        style = {style}
        itemRef={itemRef}
        itemPosition={itemPosition}
        activePosition={activePosition}
        elementDimensions={elementDimensions}
        itemDimensions={itemDimensions}
        canvasSize={canvasSize || 250}
        discFillColor={discFillColor || 'transparent'}
        discStrokeColor={discStrokeColor || 'black'}
        circlesFillColor={circlesFillColor || 'black'}
        circlesStrokeColor={circlesStrokeColor || 'transparent'}
        circlesHighlightColor={circlesHighlightColor || 'red'}
        textFillColor={textFillColor|| 'white'}
        textStrokeColor={textStrokeColor || 'transparent'}
        arrowFillColor={arrowFillColor || 'black'}
        arrowStrokeColor={arrowStrokeColor || 'transparent'}
        callback = {callback || (()=>{console.log("default callback")}) }

      />
  )
};

export default Dialpad;